export const checkStatus = (status) => {
    if(status == 1){
        return 'กำลังใช้งาน'
    }else if(status == 2){
      return 'ครบกำหนด'
    }else{
        return 'ถูกยกเลิกแล้ว'
    }
}

export const checkTypeDelegate = (type) => {
    if(type == 'MEDICAL'){
        return 'ค่ารักษาพยาบาล'
    }else if(type == 'LEAVE'){
        return 'การลา'
    }
}